import { Card, Col, Row, Typography } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { Paquetes } from "../../../types/common";
import { useCallback } from "react";
const { Text } = Typography;

interface CardRechargesProps {
    onClick: Function;
    paquete: Paquetes;
    selected: boolean;
};

const CardRecharges = (props: CardRechargesProps) => {
    const { paquete, onClick, selected } = props;
    const formatter = Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" });

    const formatMonto = useCallback((monto: string) => {
        const montoNumerico = parseFloat(monto);

        // Verificar si es un número válido
        if (isNaN(montoNumerico)) {
            return monto;
        }

        // Formatear el número
        return formatter.format(montoNumerico);
    }, [formatter]);

    return (
        <>
            <div onClick={() => onClick(paquete)} style={{ cursor: 'pointer' }}>
                <Card style={{ ...styles.cardStyle, ...(selected) && styles.cardStyleSelected }} bodyStyle={styles.bodyCard}>
                    <Row style={{ padding: 24 }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <div style={{ marginBottom: 10 }}>
                                <Text style={{ ...styles.textPrincipal, ...(selected) && styles.textSelected }}>
                                    {formatMonto(paquete.monto)}
                                </Text>
                            </div>
                            <div>
                                <Text style={{ ...styles.megaByte, ...(selected) && styles.textSelected }}>{`${paquete.datos} MB`}</Text>
                            </div>
                            <div style={{ margin: 0, padding: 0 }}>
                                <Text style={{ ...styles.text, ...(selected) && styles.textSelected }}>para navegar</Text>
                            </div>
                        </Col>
                    </Row>
                    {(paquete.vigencia > 0) && (
                        <Row style={{ marginBottom: 20 }}>
                            <div style={{ ...styles.divDays, ...(selected) && styles.divDaysSelected }}>
                                <Text style={{ ...styles.days, ...(selected) && styles.textInvertedSelected }}>
                                    {`Vigencia: ${paquete.vigencia} ${(paquete.vigencia === 1) ? "día" : "días"}`}
                                </Text>
                            </div>
                        </Row>
                    )}
                </Card>
            </div >
        </>
    );
};

const styles = StyleSheet.create({
    cardStyle: {
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 12,
    },
    bodyCard: {
        width: "100%",
        padding: 0
    },
    cardStyleSelected: {
        backgroundColor: "#0080FF",
    },
    textPrincipal: {
        fontSize: 30,
        color: '#0055c2',
        fontWeight: 600
    },
    textSelected: {
        color: "#ffffff",
    },
    textInvertedSelected: {
        color: "#0080FF",
    },
    megaByte: {
        fontSize: 25,
        color: '#a19c9c',
        fontWeight: 600,
        lineHeight: 1
    },
    text: {
        fontSize: 15,
        color: '#a19c9c',
        lineHeight: 0.5
    },
    divDays: {
        backgroundColor: '#0080FF',
        width: '100%',
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divDaysSelected: {
        backgroundColor: "#ffffff",
    },
    days: {
        fontSize: 18,
        color: 'white',
        fontWeight: 400,
        textAlign: 'center'
    }
});

export default CardRecharges;
